import { FC } from 'react';

import { BlogPostInterface } from '@/src/assets/interfaces/blogPostInterface';
import { BlogTagInterface } from '@/src/assets/interfaces/blogTagInterface';
import { baseUrl } from '@/src/assets/utils/baseUrl';
import { getImageUrl } from '@/src/assets/utils/getImageUrl';

import Wrapper from '../../UI/wrapper/Wrapper';
import { BlogFeaturedPost } from '../../blog/blogFeaturedPost/BlogFeaturedPost';
import { BlogPageHead } from '../../blog/blogPageHead/BlogPageHead';
import { BlogPosts } from '../../blog/blogPosts/BlogPosts';
//import { BlogTagsPane } from '../../blog/blogTagsPane/BlogTagsPane';
import Layout from '../../layout/Layout';

import styles from './BlogPage.module.scss';

interface BlogProps {
    blogData: BlogTagInterface;
    blogTags: BlogTagInterface[];
    blogPosts: BlogPostInterface[];
}

//TODO: RETURN BlogTagsPane WHEN THERE IS MORE TAGS

const Blog: FC<BlogProps> = ({ blogData, blogTags, blogPosts }) => {
    const jsonLd = {
        '@context': 'https://schema.org',
        '@type': blogData.slug ? 'CollectionPage' : 'Blog',
        name: blogData.metaTitle || `High Five Themes Blog`,
        headline: blogData.metaTitle || `High Five Themes Blog`,
        description: blogData.metaDescription,
        url: blogData.slug ? baseUrl(`/blog/tag/${blogData.slug}`) : baseUrl('/blog'),
        publisher: {
            '@type': 'Organization',
            name: 'High Five Themes',
            url: baseUrl(),
        },
    };

    return (
        <Layout
            meta={{
                metaTitle: blogData.metaTitle,
                metaDescription: blogData.metaDescription,
                metaImageUrl: !!blogData.ogImage && getImageUrl(blogData.ogImage),
                ogTitle: blogData.metaTitle,
                ogDescription: blogData.metaDescription,
            }}
            jsonLD={jsonLd}>
            <div className={styles.blogPage}>
                <Wrapper className={styles.blogPageContentWrapper}>
                    <BlogPageHead title={blogData.title} description={blogData.description} />
                    {/*<BlogTagsPane blogTags={blogTags} selectedTag={blogData.slug || 'all'} />*/}
                    <BlogFeaturedPost featPostData={blogData.featuredPost} />
                </Wrapper>
                <BlogPosts blogPosts={blogPosts} tag={blogData.slug || 'all'} />
            </div>
        </Layout>
    );
};

export { Blog };
